import React from 'react';
import { Link } from 'react-router-dom'

const proyects = [
    { P: 'kanjaban', L: '/kanjaban' },
    { P: 'cinegon', L: '/cinegon' },
   
   
    
];


class AppD extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionWeb">


                        <div className="titleSectionWeb">
                            <h1>Desktop apps</h1>

                        </div>
                        <svg> <rect></rect> </svg>


                        <div className="listP">

                            {proyects.map(pro => (
                                <Link to={pro.L} >

                                    <div key={pro} className={pro.P}>

                                    </div>
                                </Link>


                            ))}

                        </div>



                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default AppD;